import React from 'react';

import { ArrowUpRight, ArrowDownRight } from "lucide-react";

import Skeleton from 'react-loading-skeleton';
import { motion } from "framer-motion";

export default function CardAccount({ account, bg, loading, isMat = false }) {
    const diff = account.balance - account.oldBalance;
    const isNegative = diff < 0;

    const movement = Math.abs(diff).toFixed(2);

    const TrendChip = () => (
        <div className={`inline-flex items-center justify-center gap-1 px-3 py-1 text-xs rounded-full font-medium ${isNegative ? "bg-red-600 text-white" : "bg-green-600 text-white"}`}>
            ₹ {movement}
            {isNegative ? <ArrowDownRight size={16} /> : <ArrowUpRight size={16} />}
        </div>
    );

    return (
        <motion.div whileHover={{ scale: 1.05 }} className="cursor-pointer">
            {!loading && (
                <div className={`shadow rounded-lg border-l-[6px] ${bg}`}>
                    <div className="p-5 space-y-2">
                        <div className="text-xs text-gray-500">
                            Account Number: {account.itemId}
                        </div>
                        <div className="text-2xl font-medium">
                            {isMat ? "Unit" : "₹"} {account.balance.toFixed(2)}
                        </div>
                        <TrendChip />
                        <div className="text-sm text-gray-600">{account.description}</div>
                    </div>
                </div>
            )}
            {loading && <Skeleton className="h-[100px]" />}
        </motion.div>
    );
}
